import { Typography } from '../../../atoms/typography/typography';
import { FeaturedIcon } from '../../../ui';
import { mapper } from '@maia/icons';

type Props = {
  icon: string;
  title: string;
  content: string;
};

export function NoteContent(props: Props) {
  const { icon, title, content } = props;

  return (
    <div className="flex items-center gap-x-12">
      <FeaturedIcon variant="modern" size="sm" icon={mapper(icon)} />

      <div className="flex flex-col max-w-[300px]">
        <Typography
          variant="body-xs"
          weight="medium"
          className="text-grayscale600 block truncate"
        >
          {title}
        </Typography>
        <Typography
          variant="body-xs"
          weight="regular"
          className="text-grayscale300 block truncate"
        >
          {content}
        </Typography>
      </div>
    </div>
  );
}
